const isEmpty = (obj: any) => {
  if (
    !obj || // 👈 null and undefined check
    (!!obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype)
  )
    return true;

  return false;
};

export default isEmpty;
